import { render, staticRenderFns } from "./DropDownMenu.vue?vue&type=template&id=13476001&scoped=true&"
import script from "./DropDownMenu.vue?vue&type=script&lang=js&"
export * from "./DropDownMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropDownMenu.vue?vue&type=style&index=0&id=13476001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13476001",
  null
  
)

export default component.exports